'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colonyJsContractClient = require('@colony/colony-js-contract-client');

var _colonyJsContractClient2 = _interopRequireDefault(_colonyJsContractClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Add methods from `IRecovery.sol` to a given `ContractClient`.
 */
var addRecoveryMethods = function addRecoveryMethods(client) {
  // Callers
  client.addCaller('getRecoveryRolesCount', {
    functionName: 'numRecoveryRoles',
    output: [['count', 'number']]
  });
  client.addCaller('isInRecoveryMode', {
    output: [['inRecoveryMode', 'boolean']]
  });

  // Senders
  client.addSender('approveExitRecovery', {});
  client.addSender('enterRecoveryMode', {});
  client.addSender('exitRecoveryMode', {});
  client.addSender('removeRecoveryRole', {
    input: [['address', 'address']]
  });
  client.addSender('setRecoveryRole', {
    input: [['address', 'address']]
  });
  client.addSender('setStorageSlotRecovery', {
    input: [['slot', 'number'], ['value', 'hexString']]
  });
};

exports.default = addRecoveryMethods;
//# sourceMappingURL=addRecoveryMethods.js.map